import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { range } from "lodash";

const Pagination = ({
  currentPage,
  setCurrentPage,
  hitsPerPage,
  numHits,
  addGenericProduct,
  modelCode,
  modelName,
}) => {
  const pages = range(1, Math.ceil(numHits / hitsPerPage) + 1);

  const next = () => {
    if (currentPage < pages.length) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prev = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  return (
    <div className="configurator__pagination">
      <a
        href={`${window.location.origin}/products/csv/${window.productId}`}
        className="configurator__download configurator__download--left gtm-product-download"
        data-product-name={modelName}
        data-product-code={modelCode}
      >
        <svg>
          <use xlinkHref="#download-full-list" />
        </svg>
        Download full product list
      </a>

      {pages.length < 6 ? (
        <ul className="nav pagination pagination--dots push--right">
          {pages.map((page) => (
            <li
              key={`page-${page}`}
              className={classNames("pagination__item", {
                "is-active": currentPage === page,
              })}
            >
              <button onClick={() => setCurrentPage(page)} />
            </li>
          ))}
        </ul>
      ) : (
        <div className="pagination-select push--right">
          <div className="pagination-select__label">
            Page <span className="pagination-select__current">{currentPage}</span> of{" "}
            {pages.length}
          </div>
          <select
            onChange={(e) => setCurrentPage(Number(e.target.value))}
            value={currentPage}
          >
            {pages.map((page) => (
              <option key={`page-${page}`}>{page}</option>
            ))}
          </select>
        </div>
      )}

      {numHits > hitsPerPage && (
        <>
          <button
            className="btn btn--pagination pagination__left push-half--right"
            onClick={prev}
            disabled={currentPage === 1}
          >
            <svg>
              <use xlinkHref="#solid-arrow-left" />
            </svg>
          </button>
          <button
            className="btn btn--pagination pagination__right"
            onClick={next}
            disabled={currentPage === pages.length}
          >
            <svg>
              <use xlinkHref="#solid-arrow-right" />
            </svg>
          </button>
        </>
      )}

      <a className="btn" href="/products/product-enquiry" onClick={addGenericProduct}>
        Enquire Now
      </a>
    </div>
  );
};

Pagination.propTypes = {
  currentPage: PropTypes.number.isRequired,
  setCurrentPage: PropTypes.func.isRequired,
  hitsPerPage: PropTypes.number.isRequired,
  numHits: PropTypes.number.isRequired,
  addGenericProduct: PropTypes.func.isRequired,
  modelCode: PropTypes.string,
  modelName: PropTypes.string,
};

export default Pagination;
